import React from 'react';
import ContactForm from '../components/sections/ContactForm';
import DocumentMeta from 'react-document-meta';
class Contact extends React.Component {
  render() {
    const meta = {
      title: 'Autonomy Resources - Contact Us',
      description: 'Get your web or mobile application or integration to the finish line today'
    };
    return (
      <DocumentMeta {...meta}>
      <ContactForm className="illustration-section-01" />
      </DocumentMeta>
    );
  }
}

export default Contact;
